import { z } from 'zod'
import { evmAddressSchema } from './address'
import { erc20TokenTransferSchema } from './erc20'
import { erc721TokenTransferSchema } from './erc721'
import { erc1155TokenTransferSchema } from './erc1155'
import { transactionDetailSchema } from './transactionDetail'

const functionSchema = z.object({
  args: z.array(
    z.object({
      name: z.string(),
      type: z.string(),
      value: z.unknown(),
    }),
  ),
  interface: z.string(),
  name: z.string(),
})

export type TransactionFunction = z.infer<typeof functionSchema>

export const transactionDecodedSchema = transactionDetailSchema.extend({
  erc20Transfers: z.array(erc20TokenTransferSchema),
  erc721Transfers: z.array(erc721TokenTransferSchema),
  erc1155Transfers: z.array(erc1155TokenTransferSchema),
  from: evmAddressSchema,
  function: functionSchema.optional(),
  to: evmAddressSchema.optional(),
})

export type TransactionDecoded = z.infer<typeof transactionDecodedSchema>
